//close menu behavior

$(document).on("click", function(event){
  if((!$(event.target).closest(".menu-drawer-container").length) || ($(event.target).closest(".menu-drawer__menu li").length) ){
    $(".menu-drawer-container").removeClass("menu-opening");
    $("body").removeClass("overflow-hidden-tablet");
    $(".menu-drawer-container").removeAttr('open');
    $(".header__icon--summary").attr("aria-expanded", "false");
  }
});


//Instafeed Scripts

setTimeout(function() { 
 $(window).on('resize', function(){
   if($(window).width()>620){
     $("#insta-feed .slide-page").attr("data-slide-page","1");
   }
 }); 
 $("#insta-feed .description img").attr("src","//fatgripz.com/cdn/shop/t/126/assets/fatgripzinstagramimg.jpg?v=138208507151420896981792957029");
}, 2000);


//Lite Vimeo Fix Play Button Cursor
  
$( document ).ready(function() {
  let videoArea = $("lite-vimeo");
  let liteVimeosNumber = $('lite-vimeo').length;
  var i = 0;
  for(i = 1; i <= liteVimeosNumber; i++) {
    eval('var ' + 'videoShadow' + i + '= $(videoArea)[' + (i - 1) + '].shadowRoot;');
    eval('$(videoShadow' + i + ').find(".lvo-playbtn").css("cursor","pointer")');
  }
});

//Lazy Loading
  
$( document ).ready(function() {
   lazyload();
});